var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vmp-custom-menu-qrcode",class:{ 'qrcode-subscribe-page': _vm.$route.name == 'Subscribe' }},[_c('div',{staticClass:"comqrcode-previewbox"},[_c('div',{staticClass:"qrbox"},[_c('img',{attrs:{"src":_vm.info.imageSrc,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }